<template>
  <div :class="['op--modal-container', {'hide':!show}]" @click="close">
    <div class="op--modal">
      <div class="op--modal-content" id="form">
        <div class="form" @click.stop>
          <div class="heading">
            <span v-if="editId">Edit Admin</span>
            <span v-else>Add Admin</span>
          </div>

          <div class="error" v-if="!!error">{{ error }}</div>

          <div class="row row-padding">
            <div class="small-6 columns padding-R">
              <div class="data-field">
                <div class="label">First Name</div>
                <input type="text" :class="{'input':true, 'has-error':!!errorMsg.firstName}" v-model="firstName" />
                <span class="error-msg">{{ errorMsg.firstName }}</span>
              </div>
            </div>
            <div class="small-6 columns padding-L">
              <div class="data-field">
                <div class="label">Last Name</div>
                <input type="text" :class="{'input':true, 'has-error':!!errorMsg.lastName}" v-model="lastName" />
                <span class="error-msg">{{ errorMsg.lastName }}</span>
              </div>
            </div>
          </div>

          <div class="row row-padding">
            <div class="small-6 columns padding-R mobile">
              <div class="data-field">
                <div class="label">Email</div>
                <input type="text" :class="{'input':true, 'has-error':!!errorMsg.email}" v-model="email" />
                <span class="error-msg">{{ errorMsg.email }}</span>
              </div>
            </div>
            <div class="small-6 columns padding-L mobile">
              <div class="data-field">
                <div class="label">Mobile</div>
                <input type="text" :class="{'input':true, 'has-error':!!errorMsg.mobile}" v-model="mobile" />
                <span class="error-msg">{{ errorMsg.mobile }}</span>
              </div>
            </div>
          </div>

          <div class="row row-padding">
            <div class="small-6 columns padding-R mobile">
              <div class="data-field">
                <div class="label">Username</div>
                <input type="text" :class="{'input':true, 'has-error':!!errorMsg.username}" v-model="username" />
                <span class="error-msg">{{ errorMsg.username }}</span>
              </div>
            </div>
            <div class="small-6 columns padding-L mobile">
              <div class="data-field">
                <div class="label">Password</div>
                <input type="password" :class="{'input':true, 'has-error':!!errorMsg.password}" v-model="password" />
                <span class="password-edit" v-if="editId">Leave blank if you dont want to change the password.</span>
                <span class="error-msg">{{ errorMsg.password }}</span>
              </div>
            </div>
          </div>

          <div class="access">
            <label>Permission Access</label>

            <ul>
              <li v-for="(data, index) in fields">
                <span @click="updateStorePermission(index, !!access[index])">
                  <i class="fas fa-check-square fa-2x" v-if="!!access[index]"></i>
                  <i class="far fa-square fa-2x" v-else></i>
                  {{ data }}
                </span>
              </li>
            </ul>
          </div>


          <div class="access reports" v-if="!!access.PageAdminReports">
            <label>Reports Access*</label>

            <ul>
              <li v-for="(data, index) in reportsList">
                <span @click="updateReportPermission(index, !!reportAccess[index])">
                  <i class="fas fa-check-square fa-2x" v-if="!!reportAccess[index]"></i>
                  <i class="far fa-square fa-2x" v-else></i>
                  {{ data }}
                </span>
              </li>
            </ul>
          </div>

          <div class="fixed-footer">
            <div :class="{'button cta small warning':true, 'disabled':submitLoading}"
              @click="close">CANCEL</div>
            <div :class="{'button cta small':true, 'disabled':submitLoading}"
              @click="submitForm">
              <span v-if="editId">SAVE</span>
              <span v-else>ADD</span>
            </div>
          </div>
        </div>

        <div :class="{'op--modal-container':true, 'hide':!showSuccess}" @click="close">
          <div class="op--modal">
            <div class="op--modal-content" >
              <div class="success-box" @click.stop>
                <transition name="slide-up">
                  <i class="far fa-check-circle fa-4x" v-show="showSuccess"></i>
                </transition>
                <span v-if="editId">Successfully updated admin account.</span>
                <span v-else>Successfully created admin account.</span>

                <div class="button cta success" @click="close">Close</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiAdmin from '@/modules/api/admin'

export default {
  name: 'admin-add',
  components: {},
  data () {
    return {
      id: '',
      firstName: '',
      lastName: '',
      email: '',
      mobile: '',
      username: '',
      password: '',
      access: {},
      reportAccess: {},
      submitLoading: false,
      error: '',
      errorMsg: {
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        username: '',
        password: '',
      },
      showSuccess: false
    }
  },
  computed: {
    show () { return this.$store.state.admin.showForm },
    editId () { return this.$store.state.admin.edit.id },
    fields () { return this.$store.state.admin.accessList },
    _editData () { return this.$store.state.admin.edit },
    _permissions () { return this.$store.state.admin.permissions },
    _reportPermissions () { return this.$store.state.admin.reportPermissions },
    reportsList () { return this.$store.state.admin.reportsList }
  },
  methods: {
    close () {
      if (self.submitLoading) { return }
      this.$store.commit('admin/setShowForm', false)
      this.showSuccess = false
      this.clearForm()
      if (this.$store.state.admin.edit.id) {
        this.$store.commit('admin/setEdit', {})
        this.$store.commit('admin/setPermissions', {})
      }
    },
    clearForm () {
      this.id = ''
      this.firstName = ''
      this.lastName = ''
      this.email = ''
      this.mobile = ''
      this.username = ''
      this.password = ''
      this.access = {}
      this.errorMsg = {
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        username: '',
        password: '',
      }
    },
    updateStorePermission (field, add) {
      let self = this
      self.$store.commit('admin/updatePermission', {
        field: field,
        add: !add
      })

      // Regenerate fields
      self.access = {}
      self.access = Object.assign({}, this.$store.state.admin.permissions)
    },
    submitForm () {
      let self = this
      if (self.submitLoading) { return }

      if (!self.validate()) {
        self.scrollToTop()
        return
      }

      let fields = {
        firstName: self.firstName,
        lastName: self.lastName,
        email: self.email,
        mobile: self.mobile,
        username: self.username,
        password: self.password
      }
      self.submitLoading = true

      if (self.editId) {
        fields.id = self.editId
        ApiAdmin.updateAdmin(self, fields, function (res) {
          if (res.error) {
            self.error = res.error.message
            return
          }

          if (self.password) {
            self.updatePassword()
          } else {
            self.updatePermission()
          }
        })
      } else {
        ApiAdmin.addAdmin(self, fields, function (res) {
          self.submitLoading = false
          if (res.error) {
            self.error = res.error.message
            return
          }
          self.id = res.id
          self.updatePermission()
          // self.$store.commit('admin/setAddSuccess', true)
          // self.showSuccess = true
        })
      }
    },
    validate () {
      let self = this
      let fields = ['firstName', 'lastName', 'email', 'mobile', 'username']
      let noError = true

      if (!self.editId) { fields.push('password') }
      fields.forEach(function (field) {
        if (!self[field]) {
          self.errorMsg[field] = 'This field cannot be empty.'
          noError = false
        }
      })

      return noError
    },
    updatePassword () {
      let self = this
      ApiAdmin.updateAdminPassword(self, {
        id: self.editId,
        password: self.password
      }, function (res) {
        if (res.error) {
          self.error = res.error.message
          return
        }
        self.updatePermission()
      })
    },
    updatePermission () {
      let self = this
      ApiAdmin.updateAdminAccess(self, self.id, function (res) {
        self.submitLoading = false
        if (res.error) {
          self.error = res.error.message
          return
        }

        self.showSuccess = true
        self.$store.commit('admin/setAddSuccess', true)
        if (self.editId === self.$store.state.session.user.id) {
          self.$store.commit('session/setAccess', res.permissions)
        }
      })
    },
    scrollToTop () {
      let elmnt = document.getElementById('form')
      elmnt.scrollIntoView({behavior: 'smooth', block: 'start'})
    },
    updateReportPermission (field, add) {
      let self = this
      self.$store.commit('admin/updateReportPermission', {
        field: field,
        add: !add
      })

      // Regenerate fields
      self.reportAccess = {}
      self.reportAccess = Object.assign({}, this.$store.state.admin.reportPermissions)
    },
  },
  watch: {
    _editData: function (value) {
      if (value) {
        this.id = value.id
        this.firstName = value.firstName
        this.lastName = value.lastName
        this.email = value.email
        this.mobile = value.mobile
        this.username = value.username
      }
    },
    _permissions: function (value) {
      if (value) {
        this.access = {}
        this.access = value
      }
    },
    _reportPermissions: function (value) {
      if (value) {
        this.reportAccess = {}
        this.reportAccess = value
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.op--modal {
  display: table;
  width: 100%;
  height: 100%;
}
.op--modal-content {
  display: table-cell;
  vertical-align: middle;
}

.row-padding{ padding: 2px 30px; }
.padding-L{ padding-left: 10px; }
.padding-R{ padding-right: 10px; }
.margin-B{ margin-bottom: 20px; }

.form{
  background: #fff;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
}
.heading{
  background: #333;
  color: #fff;
  font-weight: 600;
  font-size: 21px;
  padding: 10px 20px;
  margin-bottom: 20px;
}

.data-field{
  position: relative;
  margin-bottom: 10px;
  .label{
    color: #888;
    font-weight: 600;
    font-size: 12px;
    line-height: 130%;
    margin-bottom: 1px;

    &.has-error{ color: #f20d0d; }
  }
  .input{
    margin: 1px 0 0;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
}

.password-edit{
  font-size: 12px;
  color: #888;
  line-height: 1;
}

.access{
  padding: 20px 30px;

  label{
    display: block;
    font-weight: 600;
    color: #444;
    padding-bottom: 3px;
    font-size: 14px;
    border-bottom: 1px solid #ddd;
  }
}
ul{
  list-style:none;
  padding: 0;
  width: 100%;
  text-align:left;
  -webkit-column-count: 3; /* Chrome, Safari, Opera */
  -moz-column-count: 3; /* Firefox */
  column-count: 3;

  &.one{
    -webkit-column-count: 1; /* Chrome, Safari, Opera */
    -moz-column-count: 1; /* Firefox */
    column-count: 1;
  }
  li{
    display: block;
    font-size: 14px;
    padding: 4px 0;
    cursor: pointer;
    color: #555;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    i{
      margin-right: 5px;
      color: #aaa;
      font-size: 15px;
    }
    .fa-check-square{ color: #528cce; }
    .fa-square{ color: #b5cebd; }
    &:hover, &:hover i, &.checked i{ color: #528cce; }
    &.disabled{
      opacity: .4;
      cursor: default;
    }
  }
}
.access.reports{
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 0 30px;
  padding: 0;
  background: #fffbd2;

  label{
    padding: 10px 20px;
    line-height: 1;
  }
  ul{
    padding: 0 20px;
  }
}

.error:not(.button){
  padding:5px;
  margin:0 30px 20px;
  display:block;
  font-size:14px;
  border: 1px solid #ff5b36;
  color: #ff5b36;
  font-style: italic;
}

.success-box{
  width: 400px;
  background: #fff;
  margin: 0 auto;
  padding: 20px;
  border-radius: 3px;
  text-align: center;
  color:#444;
  font-weight:600;

  i{ color: #36f18e; }
  span{
    display: block;
    margin: 15px 0 35px;
  }
  .button{
    min-width: 100px;
    margin:0 5px;
  }
}

.fixed-footer{
  width: 100%;
  background: #f3f3f3;
  border-top:1px solid #ccc;
  padding: 6px 10px;
  text-align: center;
  margin-top: 30px;

  .button{
    min-width: 120px;
    margin: 0 5px;
  }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .4s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(15px);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .row-padding{ padding: 2px 10px; }
  .mobile {
    width: 100%;
    padding: 0;
  }
  .access {
    padding: 5px 10px;
  }
  ul {
    column-count: 2;
    li {
      font-size: 12px;
      i {
        margin-right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/AdminAdd.vue